<template>
    <ul>
        <li v-for="(item, index) in durations" :key="index" class="authorization-hours">
            {{ item.category }}: {{ item.credits }} {{ authorizationLabel }}
        </li>
    </ul>
</template>

<script>
    import config from 'services/config'

    export default {
        name: 'totem-authorization-hours',
        props: {
            durations: Array,
        },
        computed: {
            authorizationLabel () {
                if (config.appLanguage === 'no') {
                    return 'oppdateringstimer'
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .authorization-hours {
        margin: 0 0 5px;
        color: $orange;
    }
</style>
